import formatDate from './format'

const hourValidate = hourAsString => {
  const format = 'HH:mm'
  return formatDate(hourAsString, format)
}

export default hourValidate
